import Handler from "../Handler";

class TourneyRebuyInAckHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyGameRebuyAck(receivedData);
  }
}
export default TourneyRebuyInAckHandler;
